import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/ideasBox/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/ideasBox/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/ideasBox/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/ideasBox/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/ideasBox/update', params, options);
export const updateSign = (params, options) =>
  request.post('/api/v4ward/ideasBox/updateSign', params, options);
export const updateAdopt = (params, options) =>
  request.post('/api/v4ward/ideasBox/updateAdopt', params, options);
export const updateRead = (params, options) =>
  request.post('/api/v4ward/ideasBox/updateRead', params, options);

export const updateCancelSign = (params, options) =>
  request.post('/api/v4ward/ideasBox/updateCancelSign', params, options);
export const updateCancelAdopt = (params, options) =>
  request.post('/api/v4ward/ideasBox/updateCancelAdopt', params, options);
